import { render, staticRenderFns } from "./HomeCurrency.vue?vue&type=template&id=1d80a73e&lang=pug&"
import script from "./HomeCurrency.vue?vue&type=script&lang=js&"
export * from "./HomeCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports